import React, { useRef } from 'react';
import TokenHandler from "./component/TokenHandler";
import useToken from "./hooks/useToken";
import CodeList from "./component/CodeList";
import MetricList from "./component/MetricList";

const styles = {
  body: {
  }
}

const getCustomerIdAndCleanPath = () => {
  let path = '/' + window.location.pathname.replaceAll('/', '');
  if (!path.endsWith('/')) {
    path += '/';
  }
  // if (window.location.pathname !== path) { // cleanup url.
  //   let url = new URL(window.location.href);
  //   url.pathname = path;
  //   window.history.replaceState(null, '', url);
  // }
  let customerId = path.substring(1, path.length - 1);
  const isAdmin = customerId === "admin";
  if (customerId === "/" || customerId === "admin" || !customerId) customerId = undefined;
  return { isAdmin, customerId };
}

function App() {
  const [token] = useToken();
  const initialState = useRef(getCustomerIdAndCleanPath());
  const { isAdmin, customerId } = initialState.current;
  return (
    <div style={styles.body}>
      <TokenHandler />
      { token ? <CodeList customerId={customerId} /> : null}
      { isAdmin && token ? <MetricList /> : null}
    </div>
  );
}

export default App;
